// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"638":"a27e157b","988":"eaf58861"}[chunkId] + ".chunk.js";
};